module.exports = __webpack_public_path__ + "static/media/ic-actions-closed-view.fe5ffcaf.svg";